export class UpdateDomainsRequest {
    equivalentDomains: string[][];
    excludedGlobalEquivalentDomains: number[];
}
